<template>
    <span>
        <v-card id="webportal-card" class="pa-3" dark v-show="showWebportalCard">
             웹으로 예매하기
        </v-card>
        <v-card id="buller-card" class="pa-3" dark v-show="showBullerCard">
             불러앱 다운로드
        </v-card>
        <v-card id="email-card" class="pa-3" dark v-show="showEmailCard">
             yhm@limokorea.co.kr
        </v-card>
        <v-card id="phone-card" class="pa-3" dark v-show="showPhoneCard">
            (02) 3141-2345
        </v-card>
        <v-card id="address-card" class="pa-3" dark v-show="showAddressCard">
            서울특별시 중구 다산로 32, 남산타운 제 5상가 328호
        </v-card>

        <v-avatar size="40px" id="webportal-button" @click="sendToNewLink('http://www.limokorea.co.kr/login.do')" @click.stop="zoomOut" @mouseover="showWebportalCard=true" @mouseleave="showWebportalCard=false" href="http://www.limokorea.co.kr/login.do">
            <img src="../../assets/logo2.png"></img>
        </v-avatar>
        <v-avatar size="40px" id="buller-button" @click="sendToNewLink('https://play.google.com/store/apps/details?id=com.limo.app')" @click.stop="zoomOut" @mouseover="showBullerCard=true" @mouseleave="showBullerCard=false" href="https://play.google.com/store/apps/details?id=kr.co.limokorea.driver">
            <img src="../../assets/bullerlogo.webp">
        </v-avatar>
        <v-btn id="email-button" fab dark small color="red" @click.stop="zoomOut" @mouseover="showEmailCard=true" @mouseleave="showEmailCard=false" to="/contact">
            <v-icon>mdi-email</v-icon>
        </v-btn>
        <v-btn id="address-button" fab dark small color="indigo" @click.stop="zoomOut" @mouseover="showAddressCard=true" @mouseleave="showAddressCard=false">
            <v-icon>mdi-home-modern</v-icon>
        </v-btn>
        <v-btn id="phone-button" fab dark small color="green" @click.stop="zoomOut" @mouseover="showPhoneCard=true" @mouseleave="showPhoneCard=false">
            <v-icon>mdi-phone</v-icon>
        </v-btn>
    </span>
</template>
<script>
export default {
    name: 'FabSpeedDial',
    data: () => ({
      showPhoneCard: false,
      showAddressCard: false,
      showEmailCard: false,
      showWebportalCard: false,
      showBullerCard: false
    }),
    methods: {
        sendToNewLink: function (url) {
            window.location.href = url;
        }
    }
}
</script>

<style lang="scss">
#webportal-card {
    position: fixed;
    right: 60px;
    bottom: 325px;
}
#buller-card {
    position: fixed;
    right: 60px;
    bottom: 275px;
}
#email-card {
    position: fixed;
    right: 60px;
    bottom: 225px;
}
#phone-card {
    position: fixed;
    right: 60px;
    bottom: 125px;
}
#address-card {
    position: fixed;
    right: 60px;
    bottom: 175px;
}
#webportal-button {
    position: fixed;
    right: 15px;
    bottom: 330px;
}
#buller-button {
    position: fixed;
    right: 15px;
    bottom: 280px;
}
#email-button {
    position: fixed;
    right: 15px;
    bottom: 230px;
}
#phone-button {
    position: fixed;
    right: 15px;
    bottom: 130px;
}
#address-button {
    position: fixed;
    right: 15px;
    bottom: 180px;
}
</style>
